module.exports = __webpack_public_path__ + "img/logo-mo-33.5ac83da6.svg";